/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icons/compass-otg': {
    width: 22,
    height: 22,
    viewBox: '0 0 22 22',
    data: '<path pid="0" d="M.182.682L21.32 10.816l-8.873 2.13-2.13 8.873L.181.682z" _fill="#000"/>'
  }
})
